import { get } from "svelte/store";

import AuthStore from "./Store";

const AuthHelpers = {};

AuthHelpers.isLoggedIn = () => {
	return AuthStore.actions.pingSession();
};

AuthHelpers._generateEmptyUserInfo = () => {
	return {
		email: "",
		username: "",
		identity: "",
		forceIdentity: "",
		forceIdentityId: -1,
		features: []
	};
};

AuthHelpers._generateEmptyToken = () => {
	return {
		id_token: "",
		access_token: "",
		refresh_token: "",
		token_type: "",
		valid_until: 0
	};
};

AuthHelpers._generateSaveData = () => {
	return {
		meta: {
			version: AuthStore.meta.version
		},
		token: get(AuthStore.token),
		userInfo: get(AuthStore.userInfo),
		session: {
			rois: get(AuthStore.session.rois).map((item) => {
				return item.asSaveData();
			}),
			alertTypes: get(AuthStore.session.alertTypes),
			company: get(AuthStore.session.company).asSaveData(),
			user: get(AuthStore.session.user).asSaveData()
		}
	};
};

AuthHelpers._generateTokenFromAWSAuthenticationResult = (authenticationResult) => {
	const token = {
		id_token: authenticationResult.IdToken,
		access_token: authenticationResult.AccessToken,
		refresh_token: authenticationResult.RefreshToken,
		token_type: authenticationResult.TokenType,
		valid_until: Math.floor(Date.now() / 1000) + authenticationResult.ExpiresIn
	};
	return token;
};
AuthHelpers._generateTokenFromAWSOAuthResult = (result) => {
	const token = {
		...result,
		valid_until: Math.floor(Date.now() / 1000) + result.expires_in
	};
	return token;
};

export default AuthHelpers;
